import { useDatepickerRangeStore } from '@/stores/DatepickerRangeStore/DatepickerRangeStore';
import { DatepickerFooter } from './DatepickerFooter';
import { DatepickerRangeFooterProps } from './DatepickerFooter.consts';

export const DatepickerRangeFooter: React.FC<DatepickerRangeFooterProps> = ({
  onRangeSelect,
}: DatepickerRangeFooterProps) => {
  const { clearDates, setIsOpen, getSelectedDates } = useDatepickerRangeStore();

  const closeDatepicker = () => {
    clearDates();
    setIsOpen(false);
  };

  const selectDates = () => {
    if (!onRangeSelect) {
      throw new Error('onRangeSelect is not provided for range datepicker');
    }
    const dates = getSelectedDates();
    onRangeSelect(dates.startDate, dates.endDate);
    closeDatepicker();
  };

  return <DatepickerFooter onClose={closeDatepicker} onSelect={selectDates} />;
};
